<template>
  <div
    v-on:mouseenter="handleHover(true)"
    v-on:mouseleave="handleHover(false)" 
    class="map-score-block map-indicator-block">
    <color-block 
          :score="indicatorScore" 
          :name="indicator.name"
          :ishovered="indicator.indicatorHovered">
    </color-block>
  </div>
</template>

<script>
import MapColorBlock from '../MapColorBlock';
import handleHover from '../../helpers/hoverHelpers';

export default {
  name: 'map-indicator',
  props: ['indicator', 'indicatorScore'],
  components: {
    'color-block': MapColorBlock,
  },
  methods: {
    handleHover,
  },
};
</script>

<style lang="less">
  .map-indicator-block {
    @media(max-width: 1100px) {
      height: 43px;
    }
  }
</style>



// WEBPACK FOOTER //
// MapIndicator.vue?548100a0